import * as React from 'react';
export const arrowUpSvg = React.forwardRef(function arrowUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M.97 4.72a.75.75 0 0 0 1.06 1.06l3.22-3.22v8.69a.75.75 0 0 0 1.5 0V2.56l3.22 3.22a.75.75 0 1 0 1.06-1.06L6.53.22a.748.748 0 0 0-1.06 0l-4.5 4.5Z',
    }),
  );
});
arrowUpSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowUp = {
  category: 'icon',
  colorable: true,
  name: 'arrowUp',
  svg: arrowUpSvg,
};
